import { defineFcm } from '../shared/factory';

export const FCM_STARTER_DASHBOARD_DECISION_MAKERS_LIST_ENABLED = defineFcm(
	'starter_dashboard_decision_makers_list_enabled',
)
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig();
